import { Card, CardContent, CardHeader } from '@/components/ui/Card';
import { AutocompleteSelect } from '@/components/Autocomplete';
import { Input, Label } from '@/components/ui/Input';
import { searchDfsRegions, type DfsLocation } from '../lib/dataforseo';
import { EligibilityAndSuppression } from '../sections/EligibilityAndSuppression';
import { useWizardStore } from '../lib/wizard-store';

export function W3_TargetEligibility() {
  const store = useWizardStore();

  function onRegionSelected(_id: string, item: DfsLocation | null) {
    if (!item) {
      store.patchW2({ target_region: '', target_region_dfs_code: null } as never);
      return;
    }
    store.patchW2({
      target_region: item.name,
      target_region_dfs_code: item.code,
    } as never);
  }

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader
          title="Affinage geographique"
          subtitle={`Pays ${store.target_country || '-'} et langue ${store.language || '-'} deja definis a l'etape precedente. Ici, on affine seulement la region et la ville utiles a la campagne.`}
        />
        <CardContent className="space-y-4" data-testid="target-section">
          <div className="rounded-brand border border-dashed border-brand-border bg-gray-50 px-4 py-3 text-sm text-gray-600">
            Le naming auto reutilise deja le pays et la langue. Cette etape sert seulement a
            preciser le territoire reel de diffusion avant les exclusions.
          </div>

          <div className="grid gap-4 md:grid-cols-2">
            <div className="space-y-1">
              <Label htmlFor="target_region">Region</Label>
              <AutocompleteSelect<DfsLocation>
                value={store.target_region}
                initialLabel={store.target_region}
                onSelect={onRegionSelected}
                onSearch={(query) => searchDfsRegions(store.target_country, query)}
                renderItem={(location) => `${location.name} (${location.type})`}
                getId={(location) => String(location.code)}
                placeholder={
                  store.target_country ? 'Rechercher une region / etat...' : "Selectionne un pays d'abord"
                }
                disabled={!store.target_country}
                queryKey={`dfs-regions-${store.target_country}`}
                data-testid="target-region"
              />
            </div>
            <div className="space-y-1">
              <Label htmlFor="target_city">Ville</Label>
              <Input
                id="target_city"
                value={store.target_city}
                onChange={(event) => store.patchW2({ target_city: event.target.value } as never)}
                placeholder="Paris"
                data-testid="target-city"
              />
            </div>
          </div>
        </CardContent>
      </Card>

      <EligibilityAndSuppression />
    </div>
  );
}
